<div class="page-tpl__container">
    <wep-image class="page-tpl__logo" [src]="awthLogoPath" [alt]="'AWTH Logo'"></wep-image>
    <h1 class="page-tpl__heading">
        <ng-content select="wep-page-tpl-login-default-heading"></ng-content>
    </h1>
    <div class="page-tpl__content">
        <ng-content select="wep-page-tpl-login-default-content"></ng-content>
    </div>
</div>